import React from 'react';
import { Container } from 'react-bootstrap';
import { FaClipboardCheck, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import Reveal from './Reveal';

const coverageAreas = [
  'Spixworth',
  'Norwich',
  'Aylsham',
  'Wroxham',
  'North Walsham',
  'Dereham',
  'Wymondham',
  'Surrounding Norfolk areas',
];

const processSteps = [
  {
    title: 'Tell us about the job',
    text: 'Share the type of work, the location and anything time-sensitive.',
  },
  {
    title: 'We arrange the next step',
    text: 'That might be a call back, a site visit or a straightforward follow-up.',
  },
  {
    title: 'You get a clear answer',
    text: 'You know whether the next step is a quote, a visit or a follow-up conversation.',
  },
];

const CoverageSection = () => {
  return (
    <section className="content-section coverage-section" id="areas">
      <Container>
        <div className="coverage-grid">
          <Reveal className="coverage-panel">
            <p className="section-eyebrow">Areas covered</p>
            <h2>Based in Spixworth, covering Norwich and Norfolk.</h2>
            <p>
              Moonwood Electrical works throughout Norfolk. If your job is
              outside the areas listed, get in touch to confirm availability.
            </p>

            <div className="coverage-badges">
              {coverageAreas.map((area, index) => {
                const Icon = index === coverageAreas.length - 1
                  ? FaClipboardCheck
                  : FaMapMarkerAlt;

                return (
                  <span className="coverage-badge" key={area}>
                    <Icon aria-hidden="true" />
                    <span>{area}</span>
                  </span>
                );
              })}
            </div>

            <a className="text-link" href="tel:+447969087406">
              <FaPhoneAlt aria-hidden="true" />
              <span>Call to check your area</span>
            </a>
          </Reveal>

          <Reveal className="steps-card" delay={120}>
            <p className="steps-card__eyebrow">What happens next</p>
            <h3>From enquiry to next step.</h3>

            <ol className="process-list">
              {processSteps.map((step, index) => (
                <li key={step.title}>
                  <span className="process-list__number">{index + 1}</span>
                  <div>
                    <strong>{step.title}</strong>
                    <p>{step.text}</p>
                  </div>
                </li>
              ))}
            </ol>
          </Reveal>
        </div>
      </Container>
    </section>
  );
};

export default CoverageSection;
